import { useFeatureFlagContext } from '@fff-web/feature-flags';
import useScreenMode from '../../../hooks/useScreenMode';
import useSubscriptionPlanPrices from '../../../hooks/useSubscriptionPlanPrices';
import { DESKTOP } from '../../constants';
import * as styles from './SubscribeTodayDisclaimer.module.scss';

const SUPPORT_LINK = 'tel:18553136267';
const DETAILS_LINK = 'https://support.fabfitfun.com/en/articles/33-what-s-your-cancellation-policy';
const TERMS_LINK = 'https://legal.fabfitfun.com/#terms-of-use';
const MEMBERSHIP_TERMS_LINK = 'https://legal.fabfitfun.com/#box-membership-terms';

const SubscribeTodayDisclaimer = () => {
  const flags = useFeatureFlagContext();
  const disclaimerPriceIncreaseFF = flags?.disclaimerPriceIncrease;
  const { seasonalPrice, annualPrice } = useSubscriptionPlanPrices();
  const screenMode = useScreenMode();

  const firstLineText = disclaimerPriceIncreaseFF
    ? 'FabFitFun is an ongoing subscription service that is automatically charged each season ($59.99 USD) or annually ($219.99 USD for 4 boxes), depending on the option chosen, to the payment method provided until you cancel.'
    : `FabFitFun is an ongoing subscription service that is automatically charged each season ($${seasonalPrice} USD) or annually ($${annualPrice} USD for 4 boxes), depending on the option chosen, to the payment method provided until you cancel.`;
  const pricesAreNotPresent = !seasonalPrice || !annualPrice;
  if (pricesAreNotPresent && !disclaimerPriceIncreaseFF) return null;

  return (
    <div data-testid="subscribe-today-disclaimer-container">
      <p className={styles.disclaimer}>
        {firstLineText} Taxes, shipping fees, and, for non-US customers, foreign exchange or
        transaction fees may also apply. You may cancel your subscription at any time before your
        next bill date online (in “My Account”) or by contacting FabFitFun Support at{' '}
        <a data-testid="fabfitfun-support-link" href={SUPPORT_LINK}>
          1.855.313.6267
        </a>
        . For more details,{' '}
        <a data-testid="more-details-link" href={DETAILS_LINK}>
          click here
        </a>
        .
      </p>
      <p className={styles.disclaimer}>
        By {screenMode === DESKTOP ? 'clicking' : 'tapping'} ‘Confirm Purchase’ you are agreeing to
        our{' '}
        <a data-testid="terms-of-use-link" href={TERMS_LINK}>
          Terms of Use and Sale
        </a>{' '}
        and{' '}
        <a data-testid="fabfitfun-membership-terms-link" href={MEMBERSHIP_TERMS_LINK}>
          FabFitFun Membership Terms
        </a>
        .
      </p>
    </div>
  );
};

export default SubscribeTodayDisclaimer;
